import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    SectionHeaderWrapper,
    SectionHeaderLabel,
    ArrowIconBoldWrapper,
} from 'src/domains/layouts/shared/cms/form/Form.style';
import { CustomizedSportsState, KeyOfOpenSectionsType } from 'src/AppState/CmsState/SportsState/SportsState';
import { action, makeAutoObservable } from 'mobx';

interface PropsTypes {
    sectionType?: KeyOfOpenSectionsType;
    label: string;
    sportState: CustomizedSportsState;
    subSection?: boolean;
}

class State {
    constructor(
        private readonly slug: KeyOfOpenSectionsType | undefined,
        private readonly handleToggleOpenSections: (slug: KeyOfOpenSectionsType) => void
    ) {
        makeAutoObservable(this);
    }

    @action handleToggle = (): void => {
        if (this.slug !== undefined) {
            this.handleToggleOpenSections(this.slug);
        }
    };
}

export const SectionHeaderComponent = observer(({ sectionType, label, sportState, subSection }: PropsTypes) => {
    const { handleToggleOpenSections, isOpenSections } = sportState;
    const [state] = React.useState(() => new State(sectionType, handleToggleOpenSections));
    const isOpen = sectionType !== undefined ? isOpenSections[sectionType] : true;

    return (
        <SectionHeaderWrapper
            subSection={subSection}
            onClick={state.handleToggle}
            isActive={sectionType !== undefined}
        >
            {sectionType !== undefined ? <ArrowIconBoldWrapper direction={isOpen ? 'down' : 'right'} /> : null}
            <SectionHeaderLabel data-test={`${label.toLowerCase().replaceAll(' ', '-')}`}>{label}</SectionHeaderLabel>
        </SectionHeaderWrapper>
    );
});
